import React from 'react';
import PropTypes from 'prop-types';

import PrismButton from '../button/prismButton';
import PrismButtonGroup from '../buttonGroup/prismButtonGroup';

const initComponent = (flex = window.flex) => {

    class PrismPageSizePicker extends React.PureComponent {
        static propTypes = {
            perPageOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
            pageSize: PropTypes.number.isRequired,
            onChangePageSize: PropTypes.func.isRequired,
            paigerLabel: PropTypes.string
        };

        static defaultProps = {
            paigerLabel: flex.text('UX_PRISM_GRID_PAGE_SIZE_PICKER_TEXT', 'Results Per Page')
        }

        render() {
            const {
                perPageOptions,
                pageSize,
                onChangePageSize,
                paigerLabel
            } = this.props;

            return (
                <div className="prism-sandbox prism-page-size-picker">
                    <small className="prism-page-size-picker__label">
                        {paigerLabel}
                    </small>
                    <PrismButtonGroup>
                        {perPageOptions.map((value, index) => (
                            <PrismButton
                                key={`page-option_${index}`}
                                buttonClassName="prism-page-size-picker__option"
                                active={pageSize === value}
                                size="sm"
                                outline
                                onClick={() => onChangePageSize(value)}
                            >
                                {value}
                            </PrismButton>
                        ))}
                    </PrismButtonGroup>
                </div>
            )
        }
    }

    return PrismPageSizePicker
};

export default initComponent;
